import 'core-js';
import React                 from 'react';
import { createRoot } from 'react-dom/client';
import './app/shared/utils/yupMethods';
import App                   from './app/App';
import { isNative }          from './app/shared/utils/platform';
import { checkSubscription } from './app/utils/subscription';

const startApp = () => {
  console.log('Starting Family Core app...');

  try {
    if (isNative) {
      document.addEventListener('deviceready', () => {
        console.log('[App] deviceready fired. window.CdvPurchase available:', !!window.CdvPurchase);
        try {
          checkSubscription();
        } catch (error) {
          console.error('[App] checkSubscription threw an error:', error);
        }
      });
    }

    const container = document.getElementById('root');
    if (container) {
      const root = createRoot(container);
      root.render(<App />);
    } else {
      console.error('Root container not found!');
    }
  } catch (error) {
    console.error('Error starting app:', error);
    // Display error on screen for debugging
    const container = document.getElementById('root');
    if (container) {
      container.innerHTML = `
        <div style="padding: 20px; color: red; font-family: monospace;">
          <h1>Error loading application</h1>
          <pre>${error instanceof Error ? error.message : String(error)}</pre>
          <pre>${error instanceof Error ? error.stack : ''}</pre>
        </div>
      `;
    }
  }
};

startApp();
